import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  capitalize,
  filterRealRouteStations,
  PLURAL_KEY,
  type ICourseDto,
} from "@ryde/shared";

import type { ICsvCellViewData } from "../../csv-list.models";
import { buildCsvCellViewData } from "../../csv-list.utils";

export const useCourseStationsCell = (
  rowOriginal: unknown,
): ICsvCellViewData => {
  const { t } = useTranslation();
  // The column value is the bare id list; the names come from the row's station info.
  const stationsInfo = (rowOriginal as ICourseDto | undefined)?.metadata
    ?.stationsInfo;

  return useMemo(
    () =>
      buildCsvCellViewData({
        displayValues: filterRealRouteStations(stationsInfo).map(
          station => station.name,
        ),
        tooltipPrefix: capitalize(`${t(`station.${PLURAL_KEY}`)}:`),
      }),
    [stationsInfo, t],
  );
};
